<template>
  <div>
    <template v-for="(question, question_index) in questions">
      <transition name="fade">
        <div v-if="question_index + 2 == step">
          <p class="question-title">{{ question.category }}</p>
          <div class="progress">
            <div class="progress-bar">
              <div class="progress" :style="{ width: ((step - 1) / questions.length) * 100 + '%' }"></div>
            </div>
          </div>
          <div class="question">
            <p class="title">{{ question.question }}</p>
            <div></div>
            <div class="inputs">
              <template v-for="(input, key) in question.inputs">
                <template v-if="input.type == 'money'">
                  <money-input
                    v-on:updateAnswer="updateAnswer"
                    :ref="key"
                    :answerKey="key"
                    :questionIndex="question_index"
                    :input="input"
                  ></money-input>
                </template>

                <template
                  v-else-if="
                    input.type == 'date_mm_yyyy' ||
                      input.type == 'date_dd_mm_yyyy'
                  "
                >
                  <date-input
                    v-on:updateAnswer="updateAnswer"
                    :ref="key"
                    :answerKey="key"
                    :questionIndex="question_index"
                    :input="input"
                  ></date-input>
                </template>

                <template v-else-if="input.type == 'phone'">
                  <phone-input
                    v-on:updateAnswer="updateAnswer"
                    :ref="key"
                    :answerKey="key"
                    :questionIndex="question_index"
                    :input="input"
                  ></phone-input>
                </template>

                <template v-else-if="input.type == 'choice'">
                  <select-input
                    v-on:updateAnswer="updateAnswer"
                    :ref="key"
                    :answerKey="key"
                    :questionIndex="question_index"
                    :input="input"
                  ></select-input>
                </template>

                <template v-else-if="input.type == 'inner_choice'">
                  <inner-select-input
                    v-on:updateAnswer="updateAnswer"
                    :ref="key"
                    :answerKey="key"
                    :questionIndex="question_index"
                    :input="input"
                  ></inner-select-input>
                </template>

                <template v-else-if="input.type == 'dropdown'">
                  <dropdown-input
                    v-on:updateAnswer="updateAnswer"
                    :ref="key"
                    :answerKey="key"
                    :questionIndex="question_index"
                    :input="input"
                  ></dropdown-input>
                </template>

                <template v-else-if="input.type == 'address'">
                  <address-input
                    v-on:updateAnswer="updateAnswer"
                    :ref="key"
                    :answerKey="key"
                    :questionIndex="question_index"
                    :input="input"
                  ></address-input>
                </template>

                <template v-else-if="input.type == 'check'">
                  <check-input
                    v-on:updateAnswer="updateAnswer"
                    :ref="key"
                    :answerKey="key"
                    :questionIndex="question_index"
                    :input="input"
                  ></check-input>
                </template>

                <template v-else-if="input.type == 'ownerDetails'">
                  <owner-input
                    v-on:updateAnswer="updateAnswer"
                    :ref="key"
                    :answerKey="key"
                    :questionIndex="question_index"
                    :input="input"
                  ></owner-input>
                </template>

                <template v-else-if="input.type == 'textarea'">
                  <textarea-input
                    v-on:updateAnswer="updateAnswer"
                    :ref="key"
                    :answerKey="key"
                    :questionIndex="question_index"
                    :input="input"
                  ></textarea-input>
                </template>

                <template v-else-if="input.type == 'upload'">
                  <upload-input
                    v-on:updateAnswer="updateAnswer"
                    :ref="key"
                    :answerKey="key"
                    :questionIndex="question_index"
                    :input="input"
                  ></upload-input>
                </template>

                <template v-else-if="input.type == 'EIN'">
                  <EIN-input
                    v-on:updateAnswer="updateAnswer"
                    :ref="key"
                    :answerKey="key"
                    :questionIndex="question_index"
                    :input="input"
                  ></EIN-input>
                </template>

                <template v-else>
                  <normal-input
                    v-on:updateAnswer="updateAnswer"
                    :ref="key"
                    :answerKey="key"
                    :questionIndex="question_index"
                    :input="input"
                  ></normal-input>
                </template>
              </template>
              <p v-if="errors.length" class="errors">
                Please enter a
                <span
                  v-for="(error, index) in errors"
                >{{ error }}{{ index + 1 == errors.length ? "." : ", " }}</span>
              </p>
              <div class="btns" v-if="show_btn">
                <button @click="nextStep(question_index, question)" class="btn">Next</button>
              </div>
            </div>
            <div v-if="show_btn">
              <button
                v-if="$parent.step > 2"
                @click="previousStep(question_index)"
                class="btn text-btn back"
              >
                <span>←</span> Back
              </button>
            </div>
          </div>
        </div>
      </transition>
    </template>
  </div>
</template>

<script>
import TextareaInput from "@/components/Application/Inputs/Textarea";
import MoneyInput from "@/components/Application/Inputs/Money";
import DateInput from "@/components/Application/Inputs/Date";
import PhoneInput from "@/components/Application/Inputs/Phone";
import SelectInput from "@/components/Application/Inputs/Select";
import InnerSelectInput from "@/components/Application/Inputs/InnerSelect";
import DropDownInput from "@/components/Application/Inputs/DropDown";
import AddressInput from "@/components/Application/Inputs/Address";
import CheckInput from "@/components/Application/Inputs/Signatures";
import OwnerInput from "@/components/Application/Inputs/ownershipDetails";
import UploadInput from "@/components/Application/Inputs/Upload";
import EINInput from "@/components/Application/Inputs/EIN";
import NormalInput from "@/components/Application/Inputs/Normal";

export default {
  name: "Questions",
  props: ["questions", "step"],
  components: {
    "money-input": MoneyInput,
    "textarea-input": TextareaInput,
    "date-input": DateInput,
    "phone-input": PhoneInput,
    "select-input": SelectInput,
    "inner-select-input": InnerSelectInput,
    "dropdown-input": DropDownInput,
    "address-input": AddressInput,
    "check-input": CheckInput,
    "owner-input": OwnerInput,
    "upload-input": UploadInput,
    "EIN-input": EINInput,
    "normal-input": NormalInput
  },
  data() {
    return {
      errors: [],
      show_btn: true
    };
  },
  mounted() {},
  created() {},
  firestore() {
    return {};
  },
  methods: {
    updateAnswer(question_index, answer_key, answer) {
      this.questions[question_index].inputs[answer_key].value = answer;
      this.$emit("saveAnswer", answer_key, answer);
    },
    changedStep(question_index, next, prev) {
      this.$parent.step = question_index + next;
      this.$parent.previous_step = question_index + prev;

      this.$store.commit("setApplicationApprovalStep", question_index + 3);
    },
    nextStep(question_index, question) {
      let questions = this.questions;
      if (this.validate(question_index)) {
        this.$parent.step = null;
        setTimeout(() => {
          if (questions.length == question_index + 1) {
            this.$parent.saveData();
            if (this.$store.state.phase == "Application Approval") {
              this.$store.commit("setApplicationApprovalStep", 1);
            }
          } else {
            if (question.skip) {
              question.skip.forEach(skip => {
                if (this.$parent.answers[skip.key] == skip.value) {
                  this.changedStep(question_index, 4, 2);
                } else {
                  this.changedStep(question_index, 3, 2);
                }
              });
            } else {
              this.changedStep(question_index, 3, 2);
            }
          }
        }, 500);
      }
    },
    previousStep(question_index) {
      this.$parent.previous_step = this.$parent.step;
      this.$parent.step = null;
      setTimeout(() => {
        this.$parent.step = this.$parent.previous_step - 1;
        this.$parent.previous_step = question_index + 1;
      }, 500);
    },
    validate(question_index) {
      this.errors = [];
      let valid = true;
      let inputs = this.questions[question_index].inputs;
      for (var key in inputs) {
        let input = inputs[key];
        if (!input.value && key != "address") {
          if (!input.optional) {
            valid = false;
            this.markError(input, key);
          }
        } else {
          if (
            input.type == "date_mm_yyyy" ||
            (input.type == "date_dd_mm_yyyy" && !input.optional)
          ) {
            if (!this.validateDate(input, key) && !input.optional)
              valid = false;
          } else if (input.type == "email" && !input.optional) {
            if (!this.validateEmail(input, key)) valid = false;
          } else if (input.type == "phone" && !input.optional) {
            if (!this.validatePhone(input, key)) valid = false;
          } else if (input.type == "choice" && !input.optional) {
            if (!this.validateChoice(input, key)) valid = false;
          } else if (input.type == "dropdown" && !input.optional) {
            if (!this.validateDropDown(input, key)) valid = false;
          } else if (input.type == "address" && !input.optional) {
            if (!this.validateAddress(input, key)) valid = false;
          } else if (input.type == "check" && !input.optional) {
            if (!this.validateCheck(input, key)) valid = false;
          } else if (input.type == "ownerDetails" && !input.optional) {
            if (!this.validateOwner(input, key)) valid = false;
          } else if (input.type == "upload" && !input.optional) {
            if (!this.validateUpload(input, key)) valid = false;
          } else if (input.type == "EIN" && input.optional) {
            if (!this.validateEIN(input, key)) valid = false;
          } else {
            this.$refs[key][0].$refs.input.classList.remove("error");
          }
        }
      }
      return valid;
    },
    markError(input, key) {
      this.$refs[key][0].$refs.input.classList.add("error");
      this.errors.push(input.error_msg);
    },
    validateDate(input, key) {
      var today = new Date();
      var inputDate = input.value.split("-");
      let year = inputDate[0];
      if (
        (input.value.length < 7 && input.type == "date_mm_yyyy") ||
        (input.value.length < 10 && input.type == "date_dd_mm_yyyy")
      ) {
        this.markError(input, key);
        return false;
      } else if (year > today.getFullYear() || year < 1600) {
        this.markError(input, key);
        return false;
      } else {
        this.$refs[key][0].$refs.input.classList.remove("error");
        return true;
      }
    },
    validateEmail(input, key) {
      var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(input.value.toLowerCase())) {
        this.$refs[key][0].$refs.input.classList.remove("error");
        return true;
      } else {
        this.markError(input, key);
        return false;
      }
    },
    validatePhone(input, key) {
      if (
        input.value.length < 14 ||
        !input.value.includes("(") ||
        input.value.length == 15 ||
        input.value.length > 16
      ) {
        this.markError(input, key);
        return false;
      } else {
        this.$refs[key][0].$refs.input.classList.remove("error");
        return true;
      }
    },
    validateChoice(input, key) {
      if (input.value) {
        return true;
      } else {
        this.markError(input, key);
        return false;
      }
    },
    validateDropDown(input, key) {
      if (input.value) {
        return true;
      } else {
        this.markError(input, key);
        return false;
      }
    },
    validateAddress(input, key) {
      if (input.value == "") {
        input.value = this.$refs.address[0].address;
        if (!input.value.address_1) {
          input.value.address_1 = document.getElementById(
            "input_address"
          ).value;
        }
      }
      if (
        input.value.address_1 &&
        input.value.city &&
        input.value.state &&
        input.value.zip
      ) {
        this.questions[1].inputs.address.value = input.value;
        this.$emit("saveAnswer", "address", input.value);
        return true;
      } else {
        this.markError(input, key);
        return false;
      }
    },
    validateCheck(input, key) {
      if (input.value) {
        return true;
      } else {
        this.markError(input, key);
        return false;
      }
    },
    validateOwner(input, key) {
      if (input.value.length) {
        return true;
      } else {
        this.markError(input, key);
        return false;
      }
    },
    validateEIN(input, key) {
      if (input.value.length == 11 || input.value == "") {
        return true;
      } else {
        this.markError(input, key);
        return false;
      }
    },
    validateUpload(input, key) {
      if (input.value.length) {
        return true;
        this.$refs[key][0].$refs.input.classList.remove("error");
      } else {
        this.markError(input, key);
        return false;
      }
    }
  },
  watch: {
    show_btn() {
      this.errors = [];
    }
  }
};
</script>

<style lang="scss">
.question-title {
  display: flex;
  flex-direction: row;
  margin-bottom: 7px;
  margin-top: 25px;
  color: #0b6efb;
  font-size: 15px;
  @media screen and (max-width: 700px) {
    padding-left: 30px;
  }
}
.progress-bar {
  background: rgba(8, 91, 209, 0.2);
  height: 7px;
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: flex-start;
  position: relative;
  overflow: hidden;
  .progress {
    background-color: #0b6efb;
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    transition: width 0.5s;
  }
}
.question {
  padding: 30px;
  background: rgba(11, 110, 251, 0.08);
  .title {
    margin: 0;
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 25px;
  }
}
.back {
  font-size: 13px;
  display: flex;
  align-items: center;
  margin-top: 10px;
  span {
    font-size: 22px;
    margin-right: 10px;
    width: 14px;
    overflow: hidden;
    margin-top: -1px;
  }
}
</style>
